// Bedien-Dichte Maus/Touch (touch-konzept Teil 1, Spezifikation 2.3).
// Regel, erste zutreffende gewinnt: 1. Viewport < 600 px → Touch. 2. Nutzerwahl localStorage['dichte'] ('maus' | 'touch').
// 3. sonst (auto, fehlend, ungültig, Speicher nicht lesbar) matchMedia('(pointer: coarse)') → Touch, sonst Maus.
// Dieselbe Regel setzt das Inline-Skript in public/index.html vor dem ersten Rendern; das Plugin hält die Klasse
// html.dichte-touch danach synchron und stellt den Zustand reaktiv bereit:
//   this.$dichte.touch (Boolean), this.$dichte.handy (Boolean), this.$dichte.wahl ('auto' | 'maus' | 'touch'),
//   this.$dichte.setzeWahl(w) schreibt localStorage['dichte'] und berechnet neu.
import Vue from 'vue';

const KEY = 'dichte';

function query(q) {
  return typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q) : null;
}

const handyQuery = query('(max-width: 599.98px)');
const grobQuery = query('(pointer: coarse)');

function normalize(w) {
  return w === 'maus' || w === 'touch' ? w : 'auto';
}

function readWahl() {
  try {
    return normalize(window.localStorage.getItem(KEY));
  } catch (e) {
    return 'auto';
  }
}

export const dichte = Vue.observable({
  touch: false,
  handy: false,
  wahl: readWahl()
});

function berechne() {
  const handy = !!(handyQuery && handyQuery.matches);
  const grob = !!(grobQuery && grobQuery.matches);
  dichte.handy = handy;
  dichte.touch = handy || dichte.wahl === 'touch' || (dichte.wahl === 'auto' && grob);
  const root = document.documentElement;
  if (dichte.touch) {
    root.classList.add('dichte-touch');
  } else {
    root.classList.remove('dichte-touch');
  }
}

export function setzeWahl(w) {
  const wahl = normalize(w);
  dichte.wahl = wahl;
  try {
    window.localStorage.setItem(KEY, wahl);
  } catch (e) {
    // Speicher nicht verfügbar: Wahl gilt bis zum Neuladen
  }
  berechne();
}

function listen(q) {
  if (!q) {
    return;
  }
  if (q.addEventListener) {
    q.addEventListener('change', berechne);
  } else if (q.addListener) {
    q.addListener(berechne);
  }
}

Object.defineProperty(dichte, 'setzeWahl', { value: setzeWahl });

let installed = false;

export default {
  install(VueCtor) {
    if (installed) {
      return;
    }
    installed = true;
    berechne();
    listen(handyQuery);
    listen(grobQuery);
    // Wahl in einem anderen Tab geändert
    window.addEventListener('storage', (e) => {
      if (e.key === KEY) {
        dichte.wahl = readWahl();
        berechne();
      }
    });
    // iOS Safari zeigt :active (Rückmeldung „gedrückt“) nur mit einem touchstart-Listener im Dokument
    document.addEventListener('touchstart', () => {}, { passive: true });
    VueCtor.prototype.$dichte = dichte;
  }
};
